<template>
  <v-app> 
    <Sidebar></Sidebar>
    <Topbar></Topbar>
    <Drawer v-if="isAuthenticated"></Drawer>
    <v-main>
      <v-container fluid>
        <transition name="slide-fade" mode="out-in">
          <router-view/>
        </transition>
      </v-container>
    </v-main>
    <Snackbar></Snackbar>   
    
    <v-tooltip 
      top
      v-if="isAuthenticated"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fixed
          dark
          fab
          bottom
          right
          color="primary"
          v-bind="attrs"
          v-on="on"
          @click="dialog = true"
        >
          <v-icon>mdi-forum</v-icon>
        </v-btn>
      </template>
      Contact
    </v-tooltip>
    <Contact 
      :dialog="dialog" 
      @CLOSE_MODAL="dialog = false"
      :subject="subject" 
      v-if="isAuthenticated" 
    ></Contact>
    <Loading
      :loading="loading"
      :message="message"
      :color="color"
    ></Loading>
    <div class="refresh-container" v-if="hashChanged && $root.env !== 'development'">
      <div class="notification-body">
        <div class="notification-button">
          <p class="text-center font12">Une mise à jour de store.brodelec.fr est disponible. Veuiller cliquer sur le bouton ci-dessous pour rafraîchir.</p>
          <p class="text-center"><span class="font10">(Ne pas mettre à jour peut entraîner des erreurs).</span></p>
        </div>
        <div class="refresh-button text-center">
        <v-btn
          dark
          color="primary"
          @click="reloadApp"
        >
          Mettre à jour
        </v-btn>
        </div>
      </div>
    </div>
    <OldCartDialog
      :show="showDialog"
      @CLOSE_RECOVER_CART_DIALOG="showDialog = false"
    ></OldCartDialog>
  </v-app>
</template>

<script>
  // MIXINS
  import { refreshPageMixin } from '@/mixins/refresh-page.mixin';
  // COMPONENTS
  import OldCartDialog from '@/components/cart/OldCartDialog'
  import Contact from '@/components/user/Contact'
  import Drawer from '@/components/cart/Drawer.vue'
  import Loading from '@/components/layout/Loading.vue'
  import Sidebar from '@/components/layout/Sidebar.vue'
  import Snackbar from '@/components/layout/Snackbar.vue'
  import Topbar from '@/components/layout/Topbar.vue'
  // EVENTS
  import { EventBus } from '@/main.js'
  import { LOADING, LOADED, OPEN_CONTACT_DIALOG, SHOW_RECOVER_CART_DIALOG } from '@/store/actions/general'

  export default {
    
    mixins: [refreshPageMixin],

    components: {
      Topbar,
      Sidebar,
      Loading,
      Drawer,
      Snackbar,
      Contact,
      OldCartDialog,
    },

    data: () => ({
      loading: false,
      message: 'Chargement...',
      color: '',
      dialog: false,
      subject: 'Demande de contact',
      showDialog: false,
    }),

    computed: {
      isAuthenticated() {
        return this.$store.getters.isAuthenticated
      }
    },

    mounted() {
      if (process.env.VUE_APP_ENV === 'PROD') {
        this.initVersionCheck('/version.json')
      }
      EventBus.$on(LOADING, message => {
        this.loading = true
        this.message = message
      })
      EventBus.$on(LOADED, () => {
        this.loading = false
      })
      EventBus.$on(OPEN_CONTACT_DIALOG, subject => {
        if (subject !== null) {
          this.subject = subject
        }
        this.dialog = true
      })
      EventBus.$on(SHOW_RECOVER_CART_DIALOG, () => {
        this.showDialog = true
      })
    }
  }
</script>

<style lang="scss">
  @import '@/styles/variables.scss';

  html {
    font-size: $font-size-root !important;
  }

  .v-application {
    font-family: $body-font-family;
  }
  
  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(15px);
    opacity: 0;
  }
  .slide-fade-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
  .refresh-container {
    width: 100%;
    height: 100%;
    z-index: 120;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #fff;
    padding: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
       -moz-box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
            box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.05);
  }
</style>